import Message from "base/Message";
import ValueHelper from "base/ValueHelper";
import Modal from "modal/Modal";
import moment from "moment";

export default class FindInvoiceModal extends Modal {


    constructor(subscription, entry) {
        super({
            "class": "admin-modal--large",
        });

        this.requestId = 0;
        this.subscription = subscription;
        this.entry = entry;

        this.getSubscriptionRequest = Ajax.get("billing", "subscriptions/" + subscription);

        this.buildModal();
        this.bindEvents();

        this.updateResults();
    }

    bindEvents() {
        const me = this;
        this.$content.on("click", ".js-cancel", () => {
            this.hide();
            return false;
        }).on("click", ".js-select-invoice-line", function () {
            let $btn = $(this);

            if ($btn.is(".admin-btn--loading")) {
                return false;
            }
            $btn.addClass("admin-btn--loading");

            let line = $(this).attr("data-line");

            Ajax.put("billing", "subscriptions/" + me.subscription + "/entries/" + me.entry + "/line", {line}).then(async (line) => {
                let invoice = await Ajax.get(null, line.links.invoice);

                me.emit("linked", {
                    line,
                    invoice,
                });
                me.hide();
            }).catch((e) => {
                console.log("Couldn't link invoice", e);
                new Message(e.message, "An error occurred");
                $btn.removeClass("admin-btn--loading");
            });
            return false;
        }).on("change", ".js-search-type", () => {
            let type = this.getSearchType();

            this.$content.find(".js-search-form").toggle(type === "search");
            this.updateResults();
        }).on("submit", ".js-search-form", () => {
            this.updateResults();
            return false;
        });
    }

    buildModal() {
        this.setContent(
            eotwJSXFactory('div', {className: "admin-form"}, [
                eotwJSXFactory('h1', null, ["Find Invoice"]),
                eotwJSXFactory('p', null, ["Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos enim exercitationem harum impedit iste maxime officiis quae quaerat repudiandae rerum."]),

                eotwJSXFactory('form', {className: "admin-form__row"}, [
                    eotwJSXFactory('label', {className: "admin-form__label admin-form__label--checkbox-inline admin-form__label--checkbox admin-form__label--smargin"}, [
                        eotwJSXFactory('input', {type: "radio", name: "search-type", className: "admin-form__radio-checkbox js-search-type", value: "recommended", checked: true}),
                        "Recommended Invoices"
                    ]),
                    eotwJSXFactory('label', {className: "admin-form__label admin-form__label--checkbox-inline admin-form__label--checkbox admin-form__label--smargin"}, [
                        eotwJSXFactory('input', {type: "radio", name: "search-type", className: "admin-form__radio-checkbox js-search-type", value: "search"}),
                        "Search for Invoice"
                    ])
                ]),

                eotwJSXFactory('form', {className: "js-search-form admin-flex-container admin-flex-container--align-end", style: "display: none"}, [
                    eotwJSXFactory('div', {className: "admin-form__row"}, [
                        eotwJSXFactory('label', {htmlFor: "search-invoice-number", className: "admin-form__label"}, ["Invoice Number"]),
                        eotwJSXFactory('input', {type: "text", className: "admin-form__input js-invoice-search", name: "invoice-number", id: "search-invoice-number", value: ""})
                    ]),
                    eotwJSXFactory('div', {className: "admin-form__row admin-form__row--no-grow"}, [
                        eotwJSXFactory('button', {type: "submit", className: "admin-btn admin-btn--no-flex-change"}, ["Search"])
                    ])
                ]),

                eotwJSXFactory('div', {className: "js-search-results"}),

                eotwJSXFactory('div', {className: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {className: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                ])
            ]),
        );
    }

    displayRecommendedResults(results) {
        let $results = this.getResultsElement();

        $results.html(
            eotwJSXFactory('div', {className: "admin-table"}, [
                eotwJSXFactory('div', {className: "admin-table__tr admin-table__tr--5-cols"}, [
                    eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"}, ["Invoice #"]),
                    eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"}, ["Invoice Date"]),
                    eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"}, ["Label"]),
                    eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"}, ["Net Value"]),
                    eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"})
                ]),
                results.map(({line, invoice}) => FindInvoiceModal.create_result_row(invoice, line))
            ]),
        );
    }

    async displayResults(type, results) {
        if (results.length === 0) {
            this.getResultsElement().html(
                Message.get_inline_message('No invoices matched your search. Please try a different search', 'No Results', Message.NOTICE),
            );
            return;
        }

        if (type === 'search') {
            await this.displaySearchResults(results);
        } else {
            await this.displayRecommendedResults(results);
        }
    }

    async displaySearchResults(results) {
        let $results = this.getResultsElement();

        let subscription = await this.getSubscription();

        $results.empty();
        for (let invoice of results) {
            $results.append(
                eotwJSXFactory('div', {className: "invoice-results-wrap"}, [
                    eotwJSXFactory('h3', null, ["Invoice ", invoice.invoiceNumber, " - ", moment.unix(invoice.invoiceDate.timestamp).format("DD/MM/YYYY")]),
                    eotwJSXFactory('div', {className: "admin-table"}, [
                        eotwJSXFactory('div', {className: "admin-table__tr admin-table__tr--5-cols"}, [
                            eotwJSXFactory('div', {className: "admin-table__td admin-table__td--2-wide admin-table__td--th"}, ["Label"]),
                            eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"}, ["Type"]),
                            eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"}, ["Net Value"]),
                            eotwJSXFactory('div', {className: "admin-table__td admin-table__td--th"})
                        ]),
                        invoice.lines.map((line) => (
                            eotwJSXFactory('div', {className: "admin-table__tr admin-table__tr--5-cols " + (line.type.id !== subscription.type.id ? "admin-table__tr--faded" : "")}, [
                                eotwJSXFactory('div', {className: "admin-table__td admin-table__td--2-wide"}, [line.displayLabel]),
                                eotwJSXFactory('div', {className: "admin-table__td"}, [line.type.name]),
                                eotwJSXFactory('div', {className: "admin-table__td"}, [ValueHelper.format_money(line.netValue)]),
                                eotwJSXFactory('div', {className: "admin-table__td"}, [
                                    eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--table admin-btn--primary js-select-invoice-line", disabled: line.links.subscriptionEntry !== null, 'data-invoice': invoice.id, 'data-line': line.id}, ["Select"])
                                ])
                            ])
                        ))
                    ])
                ]),
            );
        }
    }

    getResultsElement() {
        return this.$content.find(".js-search-results");
    }

    async getSearchResults() {
        const searchType = this.getSearchType();

        if (searchType === "recommended") {
            return Ajax.get("billing", 'subscriptions/' + this.subscription + "/entries/" + this.entry + "/line/search/recommended");
        }

        let query = this.$content.find(".js-invoice-search").val();

        if (query === '') {
            return [];
        }

        return Ajax.get("billing", 'subscriptions/' + this.subscription + "/entries/" + this.entry + "/line/search/", {"invoice-number": query});
    }

    getSearchType() {
        return this.$content.find(".js-search-type:checked").val();
    }

    async getSubscription() {
        return this.getSubscriptionRequest;
    }

    async updateResults() {
        try {
            let requestId = ++this.requestId;

            this.$content.find(".js-search-results").html(
                eotwJSXFactory('div', {className: "admin-loader-wrap"}, [
                    eotwJSXFactory('div', {className: "admin-loader"})
                ]),
            );
            let type = this.getSearchType();
            let results = await this.getSearchResults();

            if (this.requestId !== requestId) {
                return;
            }

            await this.displayResults(type, results);
        } catch (e) {
            console.log("Error when updating results", e);
            this.$content.find(".js-search-results").html(Message.get_inline_message(e.message, "An error occurred"));
        }
    }

    static create_result_row(invoice, line) {
        return (
            eotwJSXFactory('div', {className: "admin-table__tr admin-table__tr--5-cols"}, [
                eotwJSXFactory('div', {className: "admin-table__td"}, ["line " + (line.line + 1) + " of " + invoice.invoiceNumber]),
                eotwJSXFactory('div', {className: "admin-table__td"}, [moment.unix(invoice.invoiceDate.timestamp).format("DD/MM/YYYY")]),
                eotwJSXFactory('div', {className: "admin-table__td"}, [line.label]),
                eotwJSXFactory('div', {className: "admin-table__td"}, [ValueHelper.format_money(line.netValue)]),
                eotwJSXFactory('div', {className: "admin-table__td"}, [
                    eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--table admin-btn--primary js-select-invoice-line", 'data-invoice': invoice.id, 'data-line': line.id}, ["Select"])
                ])
            ])
        );
    }
}
